if (!customElements.get('coco-cart-upsell')) {
  customElements.define('coco-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('select').addEventListener('change', event => event.stopPropagation());
      this.querySelector('button').addEventListener('click', () => this.addPattern());
    }
    async addPattern() {
      const button = this.querySelector('button');
      if (button.disabled) return;
      const original = button.textContent;
      const error = this.querySelector('[role="alert"]');
      const root = window.Shopify?.routes?.root || '/';
      button.disabled = true;
      button.textContent = this.dataset.loading;
      error.hidden = true;
      let added = false;
      try {
        const current = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
        if (!current.ok) throw new Error('Cart unavailable');
        const cart = await current.json();
        if (cart.items.some(item => item.product_id === 8430943273236)) {
          window.location.assign(`${root}cart`);
          return;
        }
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:Number(this.querySelector('select').value),quantity:1}],sections:['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer'],sections_url:window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('Add failed');
        added = true;
        const drawer = document.querySelector('cart-drawer');
        if (this.dataset.context === 'drawer' && drawer && result.sections?.['cart-drawer']) {
          drawer.renderContents(result);
          drawer.querySelector('#CartDrawer-Checkout')?.focus();
        } else {
          window.location.assign(`${root}cart`);
        }
      } catch (_) {
        if (added) { window.location.assign(`${root}cart`); return; }
        error.textContent = this.dataset.error;
        error.hidden = false;
        button.disabled = false;
        button.textContent = original;
      }
    }
  });
}
